const React = require('react');
const PropTypes = require('prop-types');
const { Legend, Line, Tooltip } = require('recharts');
const moment = require('moment');
const LegendEntries = require('components/charts/LegendEntries/LegendEntries');
const TooltipValueTitle = require('components/charts/TooltipValueTitle/TooltipValueTitle');
const YearlyBarsLinesChart = require('components/charts/YearlyBarsLinesChart/YearlyBarsLinesChart');
const currencySymbol = require('utilities/currencySymbol');
const {
    formatAmount,
    formatWithoutRound,
} = require('utilities/currencyHelper');
const { getStartDayOfMonth } = require('utilities/dateHelper');

const GrowthChart = ({ /*benchmark,*/ data, fund, dateTruncate }) => (
    <YearlyBarsLinesChart
        data={data}
        height={400}
        tickFormatter={v =>
            `${formatWithoutRound(v)} ${
                currencySymbol(
                    fund.custom ? fund.custom.customPurchaseCurrency : '',
                )
                    ? currencySymbol(
                          fund.custom ? fund.custom.customPurchaseCurrency : '',
                      )
                    : '€'
            }`
        }
        width="100%"
    >
        <Line
            dataKey="growth"
            dot={false}
            name={fund.name}
            unit={currencySymbol(
                fund.custom ? fund.custom.customPurchaseCurrency : '',
            )}
            stroke="#ffc200"
            strokeWidth={2}
        />
        {/* TODO @Ale: This line is bound to the "benchmark" key in the received data. That benchmark should be correctly calculated. */}
        {/*
        <Line connectNulls dataKey="benchmark" dot={false} name={benchmark.name} unit={currencySymbol(fund.custom.customPurchaseCurrency)} stroke="#68748c" strokeWidth={2} />
        */}
        <Tooltip
            content={
                <TooltipValueTitle
                    titleKey={properties =>
                        getStartDayOfMonth(
                            properties.payload[0].payload.date,
                            dateTruncate,
                        )
                    }
                    titleFormat={title => moment(title).format('DD MMM YYYY')}
                    valueFormat={v => formatAmount(Number(v).toFixed(2))}
                />
            }
        />
        <Legend content={LegendEntries} iconClass="icon-radio-check" />
    </YearlyBarsLinesChart>
);

GrowthChart.defaultProps = {
    dateTruncate: false,
};

GrowthChart.propTypes = {
    benchmark: PropTypes.object.isRequired,
    data: PropTypes.array.isRequired,
    fund: PropTypes.object.isRequired,
    dateTruncate: PropTypes.bool,
};

module.exports = GrowthChart;
